/**
 * Memória por área (SPEC-v2 2.4): cada área guarda a última rota e a query no `localStorage`, sem
 * dado pessoal. Voltar para a área abre no mesmo ponto. Toda leitura e escrita é protegida.
 */
import type { Area } from '@rota/contracts';

const key = (a: Area): string => `rota:area:${a}`;
const LAST_AREA = 'rota:area:last';

/** Caminho relativo à área (ex.: "/conversas?fila=suporte"). */
export function rememberRoute(area: Area, path: string): void {
  try {
    localStorage.setItem(key(area), path);
    localStorage.setItem(LAST_AREA, area);
  } catch {
    // storage bloqueado: segue sem memória
  }
}

export function lastRoute(area: Area): string | null {
  try {
    const v = localStorage.getItem(key(area));
    // Só caminhos internos (nunca `//host` nem URL absoluta).
    return v?.startsWith('/') && !v.startsWith('//') ? v : null;
  } catch {
    return null;
  }
}

export function lastArea(): Area | null {
  try {
    const v = localStorage.getItem(LAST_AREA);
    return v === 'painel' || v === 'automacoes' || v === 'estudio' || v === 'palco' ? v : null;
  } catch {
    return null;
  }
}

/** Endereço completo para entrar na área: a última rota lembrada ou a raiz da área. */
export function areaEntry(area: Area): string {
  const last = lastRoute(area);
  return `/${area}${last && last !== '/' ? last : ''}`;
}
